import { FC } from "react";

export interface CopyLinkButtonProps {
  onClick: () => void;
  title: string;
  /** Extra classes appended to the base (e.g. "flex-1 md:flex-auto"). */
  className?: string;
}

const baseClassName =
  "flex items-center justify-center p-2.5 text-gray-700 hover:text-gray-900 bg-gray-50 border border-gray-300 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:text-gray-100";

/**
 * Button that copies the current filters as a shareable link. Reproduces the
 * link icon button repeated in the orders and locations filter bars.
 */
export const CopyLinkButton: FC<CopyLinkButtonProps> = ({
  onClick,
  title,
  className = "",
}) => (
  <button onClick={onClick} className={`${className} ${baseClassName}`} title={title}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
      />
    </svg>
  </button>
);
